class Hierarchy {
  constructor(_defaultVal) {
    this._defaultVal = _defaultVal;
  }

  subh(path) {
    let cur = this;
    path.forEach((k) => {
      if (!cur[k]) {
        cur[k] = new Hierarchy(this._defaultVal);
      }
      cur = cur[k];
    });
    return cur;
  }

  get(path) {
    if (!path) {
      return this._val === undefined ? this._defaultVal : this._val;
    }

    let cur = this;
    for (let i = 0; i < path.length; i++) {
      cur = cur[path[i]];
      if (!cur) {
        return this._defaultVal;
      }
    }
    const curVal = cur._val;
    return curVal === undefined ? this._defaultVal : curVal;
  }

  set(path, val) {
    let cur = this;
    for (let i = 0; i < path.length; i++) {
      const k = path[i];
      if (!cur[k]) {
        cur[k] = new Hierarchy(this._defaultVal);
      }
      cur = cur[k];
    }
    cur._val = val;
  }
}

export default Hierarchy;



// WEBPACK FOOTER //
// src/core/hierarchy.js